import { createContext } from 'react';
import type { SUB_ID_TYPES } from '../../constants';
import type { JobType } from '../../entities';

export interface AppContextProps {
  title: string;
  gaTrackingId: string;
  gaTrackingId_prod: string;
  gaTrackingId_dev: string;
  crossDomains: string;
  awConversionId: string;
  languages: string[];
  supportMail: string;
  supportSubject: string;
  singleProductId: number;
  subscriptionIds: SUB_ID_TYPES;
  iosUrl: string;
  androidUrl: string;
  url: string;
  wpLandingPage: string;
  jobType: JobType;
  inviteFriends: string;
  helpLink: string;
  isMusehub: boolean;
  musehubPurchaseUrl: string;
  musehubBillingUrl: string;
}

export const initConstantValues: AppContextProps = {
  title: '',
  jobType: null,
  gaTrackingId: '',
  gaTrackingId_prod: '',
  gaTrackingId_dev: '',
  crossDomains: '',
  awConversionId: '',
  languages: [],
  supportMail: '',
  supportSubject: '',
  singleProductId: null,
  subscriptionIds: null,
  iosUrl: '',
  androidUrl: '',
  wpLandingPage: '',
  inviteFriends: '',
  url: '',
  helpLink: '',
  isMusehub: false,
  musehubPurchaseUrl:
    'musehub://product/store?id=62dd72a0-9af1-4116-97b4-92ea4eb5cbd7&type=application',
  musehubBillingUrl: 'https://account.musehub.com/billing',
};
const AppConstantsContext = createContext<AppContextProps>(initConstantValues);

export default AppConstantsContext;
